export default __webpack_public_path__ + "static/Perks-b31d298793b2310f7d72ad813c007227.png";